import { Store } from 'pullstate';
import { PuzzleStoreBase, PuzzleStoreBaseDefaults } from '../../../utils/types';

export type TriwordStoreType = PuzzleStoreBase & {
  // puzzle data
  solution: string;
  fragments: string[];
  fragmentsWith1PositionRevealed: string[];
  fullWords: string[];
  obscureSolutions: string[];
  positionLifeline: string;
  lettersFor5050: string; // the 13 letters we grey out on the keyboard when 50/50 is used
  
  // user progress state data
  guess: string[];
  numInputs: number;
  wrongGuess: boolean;
  
  // lifeline usage data
  usedPositionLifeline: boolean;
  usedLetterLifeline: boolean;
  used5050Lifeline: boolean;
};

export const TriwordStore = new Store<TriwordStoreType>({
  ...PuzzleStoreBaseDefaults,
  solution: '',
  fragments: [],
  fragmentsWith1PositionRevealed: [],
  fullWords: [],
  obscureSolutions: [],
  positionLifeline: '',

  guess: [],
  numInputs: 3,
  wrongGuess: false,

  usedPositionLifeline: false,
  usedLetterLifeline: false,
  used5050Lifeline: false,
  lettersFor5050: '',
});